const initialState = {
    roleList: [],
    roleStatus: [],
    rolePermissions: {},
    changedroleStatus : [],
    loadingRole: false,
    errorsRole: {},
    roleCount:0,
}

const  RoleReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_ROLELIST_PENDING":
        case "UPDATE_ROLE_PENDING":
        case "ADD_ROLE_PENDING":
        case "DELETE_ROLE_PENDING":
        case "GET_ROLELISTBYID_PENDING":
            return { ...state, loadingRole: true };

        case "GET_ROLELIST_FULFILLED":
            return {
                ...state,
                loadingRole: false,
                roleList: action.payload,
                roleCount: action.roleCount,
                rolePermissions:action.permissions,
            };

        case "ADD_ROLE_FULFILLED":
            return {
                ...state,
                loadingRole: false,
                changedroleStatus: action.payload,
            };

       

        case "UPDATE_ROLE_FULFILLED":
            return {
                ...state,
                loadingRole: false,
                changedroleStatus: action.payload,
            };

        case "GET_ROLELISTBYID_FULFILLED":
            return {
                ...state,
                loadingRole: false,
                roleList: action.payload
            };

        case "DELETE_ROLE_FULFILLED":
            return {
                ...state,
                loadingRole: false,
                changedroleStatus: action.payload
            };

        case "RESET_DELETE_ROLE_STATUS":
            return {
                ...state,
                loadingRole: false,
                changedroleStatus: [],
                errorsRole:{}
            };

        case "GET_ROLELIST_REJECTED":
        case "ADD_ROLE_REJECTED":
        case "DELETE_ROLE_REJECTED":
        case "GET_ROLELISTBYID_REJECTED":
        case "UPDATE_ROLE_REJECTED":
          return {
                ...state,
                loadingRole: false,
                errorsRole: action.payload
            };

        default:
            return state;
    }
}

export default RoleReducer;
